import { useEffect, useState } from 'react';
import './NotificationItem.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { calculateSent } from '../../utilities/services/calculateSentDate';

export default function NotificationItem({notification, markAsRead}) {
    const [sent, setSent] = useState('');

    useEffect(() => {
        setSent(calculateSent(notification.createdAt));
        const interval = setInterval(() => {
            setSent(calculateSent(notification.createdAt))
        }, 60000); // Update every minute
        return () => clearInterval(interval);
        //eslint-disable-next-line
    }, [notification]);
  return (
    <div className={`NotificationItem ${notification.read ? 'read' : 'unread'}`} onClick={() => markAsRead(notification._id)}>
        <div className='content'>
            <div className='message'>{notification.message}</div>
            <div className='reference'>{capitalizeFirstLetter(notification.keyReference)}</div>
        </div>
        <div className='info'>
            {!notification.read &&
            <div className='unread'></div>
            }
            <div className='sent'>{sent}</div>
        </div>
    </div>
  )
}
